export const valoracionLegend = [
    {
      key: 1,
      value: "Bajo",
    },
    {
      key: 2,
      value: "Regular",
    },
    {
      key: 3,
      value: "Bueno",
    },
    {
      key: 4,
      value: "Muy bueno",
    },
    {
      key: 5,
      value: "Excelente",
    },
  ];